export default "/_next/static/images/transform-card-db12fd67e93139a381662232ab82367a.png";